import React from 'react';
import $ from '../../common/AjaxRequest';
import moment from 'moment';
import { Table, Modal } from 'antd';
import API_URL from '../../common/url';
import SideNav from './SideNav';
import Highcharts from 'react-highcharts';
import chartsConfig from '../common/chartsConfig';

const monthFormat = 'YYYY-MM'

class ChartsFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      loading: false,
      titleArray: [],
      sucArray: [],
      sucPercentArray: [],
      totalArray: [],
      totalPercentArray: [],
      filterReason: [],
      title: '',
      params: {},
      date: {},
      name: this.props.match.params.name,
      chartstype: 'column',
      url: '',
      sources: [],
      columns: [],
      keys: [],
      values: [],
    };
  }
  loadData = (url, params, date = { end: moment().format(monthFormat), begin: moment().subtract(11, 'months').format(monthFormat) }) => {
    this.setState({ loading: true });
    const name = this.props.match.params.name
    const options = {
      method: 'POST',
      url: url,
      data: {
        ...params,
        ...date,
      },
      dateType: 'json',
      doneResult: (data => {
        if (!data.error) {
          if (name === 'filterSource') {
            this.setState({
              loading: false,
              columns: data.columns || [],
              sources: data.sources || [],
              titleArray: data.titleArray || [],
              sucArray: data.sucArray || [],
              sucPercentArray: data.sucPercentArray || [],
              totalArray: data.totalArray || [],
              totalPercentArray: data.totalPercentArray || [],
            });
          } else {
            this.setState({
              loading: false,
              filterReason: data.datas || [],
              titleArray: data.titleArray,
              columns: data.columns || [],
              sources: data.sources || [],
              keys: data.keys,
              values: data.values,
            });
          }
        } else {
          this.setState({ loading: false });
          Modal.error({ title: data.error });
        }
      })
    }
    $.sendRequest(options)
  }

  reload = () => {
    this.loadData();
  }

  getdataSource = () => {
    const { sources } = this.state;
    name = this.props.match.params.name
    const data = []

    if (name === 'filterSource') {
      const type = ['预筛数量', '预筛占比', '预筛成功数量', '预筛成功占比']
      type.map((d, i) => {
        data.push({
          index: d,
          ...sources[i]
        })
      })

    } else if (name == 'filterReason') {
      const type = ['预筛失败数量', '占比']
      type.map((d, i) => {
        data.push({
          index: d,
          ...sources[i]
        })
      })
    }
    return data;
  }

  getColumns = () => {
    const { name, columns } = this.state
    const Tcolumns = []
    let titleName = '';
    if (name == 'filterSource') {
      titleName = '预筛来源';
    } else if (name == 'filterReason') {
      titleName = '预筛失败原因';
    }
    Tcolumns.push({
      title: titleName,
      dataIndex: 'index',
      key: 'index',
    })
    Tcolumns.push(...columns)
    return Tcolumns
  }

  //组件加载时初始化参数
  init = (name) => {
    let params = {}
    let title = ''
    let url = ''
    switch (name) {
      case 'filterSource':
        title = '预筛来源统计'
        params = {
          investigationId: 1,
          investigationSiteId: '',
        }
        url = `${API_URL.summary.queryPatientSource}`
        break;
      case 'filterReason':
        title = '预筛失败原因统计'
        params = {
          investigationId: 1,
          investigationSiteId: '',
        }
        url = `${API_URL.summary.queryFilterFailReason}`
        break;
    }

    this.setState({
      title,
      params,
      url
    })
    this.loadData(url, params);
  }

  componentWillMount() {
    const name = this.props.match.params.name
    this.init(name)
  }

  componentDidMount() {
    chartsConfig.exporting.buttons.contextButton.menuItems = [
      'downloadJPEG', 'downloadPDF', 'downloadPNG', 'downloadSVG',
    ];
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.name !== this.props.match.params.name) {
      this.setState({
        sources: [],
        columns: [],
        url: '',
      }, function () {
        this.setState({
          name: nextProps.match.params.name
        })
        this.init(nextProps.match.params.name)
      })
    }
  }

  showPreviewModal = id => {
    this.previewModalRef.show(id)
  }

  render() {
    const { loading, title, chartstype, keys, values, name, titleArray, totalArray, sucArray } = this.state;
    let chartSeries = []
    if (name === 'filterSource') {
      chartSeries.push({
        data: totalArray,
        name: '预筛数量'
      })
      chartSeries.push({
        data: sucArray,
        name: '预筛成功数量'
      })
    } else if (name === 'filterReason') {
      chartSeries.push({
        data: values,
        name: '预筛失败数量'
      })
    }

    const config = {
      title: {
        text: ''
      },
      chart: {
        type: chartstype
      },
      legend: {
        align: 'right',
        verticalAlign: 'top',
        x: 0,
        y: 20,
        layout: 'vertical',
      },
      yAxis: {
        title: {
          text: ''
        },
      },
      xAxis: {
        categories: name === 'filterSource' ? titleArray : keys
      },
      series: chartSeries,
      exporting: {
        chartOptions: {
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        }
      },
      credits: {
        enabled: false,
        text: 'SMO医疗大数据',
      },
    };
    return (
      <div className="content">
        <SideNav ref={el => { this.siderRef = el; }} />
        <div className="main">
          <div className="T-tit">
            <div className="txt">
              <h3 style={{ marginBottom: 10 }}>{title} </h3>
            </div>
          </div>
          <div className="charts" style={{ marginBottom: 10 }}>
            <Highcharts config={{ ...config, ...chartsConfig }} />
          </div>
          <div className="content">
            <Table
              columns={this.getColumns()}
              dataSource={this.getdataSource()}
              rowKey={record => record.key}
              loading={loading}
              pagination={false}
              bordered
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ChartsFilter;



// WEBPACK FOOTER //
// ./src/components/summary/ChartsPreFilter.js